import { render, staticRenderFns } from "./IconNewTask.vue?vue&type=template&id=0e76bc41&functional=true&"
import script from "./IconNewTask.vue?vue&type=script&lang=js&"
export * from "./IconNewTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports